import ServicesCoverages from "../../components/Services/ServicesCoverages/ServicesCoverages";

function ServicesCoveragesPage() {
  return <ServicesCoverages />;
}

export default ServicesCoveragesPage;
